export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./General.vue?vue&type=template&id=54106f5a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/General.vue?vue&type=template&id=54106f5a&scoped=true
// module id = 1729
// module chunks = 31